var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.pageReady
      ? _c(
          "div",
          [
            _c(
              "v-flex",
              { attrs: { xs12: "", "text-xs-left": "" } },
              [
                _c(
                  "v-layout",
                  { attrs: { row: "", wrap: "" } },
                  [
                    _c("v-icon", { attrs: { color: "secondary" } }, [
                      _vm._v("mdi-account-card-details")
                    ]),
                    _vm._v(" "),
                    _c("h3", { staticClass: "header-class" }, [
                      _vm._v("Student Info")
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { class: { mobile: _vm.isMobile, desktop: !_vm.isMobile } },
                  [
                    _c(
                      "v-layout",
                      { attrs: { row: "", wrap: "" } },
                      [
                        _c(
                          "v-flex",
                          {
                            staticClass: "data-title",
                            attrs: { xs5: "", md3: "" }
                          },
                          [_vm._v("Name:")]
                        ),
                        _vm._v(" "),
                        _c("v-flex", { attrs: { xs7: "", md9: "" } }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.submissionData.studentFirstName) +
                              "\n            " +
                              _vm._s(_vm.submissionData.studentLastName) +
                              "\n          "
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-layout",
                      { attrs: { row: "", wrap: "" } },
                      [
                        _c(
                          "v-flex",
                          {
                            staticClass: "data-title",
                            attrs: { xs5: "", md3: "" }
                          },
                          [_vm._v("ID:")]
                        ),
                        _vm._v(" "),
                        _c("v-flex", { attrs: { xs7: "", md9: "" } }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.submissionData.studentExtId) +
                              "\n          "
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-layout",
                      { attrs: { row: "", wrap: "" } },
                      [
                        _c(
                          "v-flex",
                          {
                            staticClass: "data-title",
                            attrs: { xs5: "", md3: "" }
                          },
                          [_vm._v("School:")]
                        ),
                        _vm._v(" "),
                        _c("v-flex", { attrs: { xs7: "", md9: "" } }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.submissionData.studentSchoolName) +
                              " (" +
                              _vm._s(_vm.submissionData.schoolCode) +
                              ")\n          "
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-layout",
                      { attrs: { row: "", wrap: "" } },
                      [
                        _c(
                          "v-flex",
                          {
                            staticClass: "data-title",
                            attrs: { xs5: "", md3: "" }
                          },
                          [_vm._v("Gender:")]
                        ),
                        _vm._v(" "),
                        _c("v-flex", { attrs: { xs7: "", md9: "" } }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.submissionData.gender) +
                              "\n          "
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-layout",
                      { attrs: { row: "", wrap: "" } },
                      [
                        _c(
                          "v-flex",
                          {
                            staticClass: "data-title",
                            attrs: { xs5: "", md3: "" }
                          },
                          [_vm._v("Grade:")]
                        ),
                        _vm._v(" "),
                        _c("v-flex", { attrs: { xs7: "", md9: "" } }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.submissionData.grade) +
                              "\n          "
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-layout",
                      { attrs: { row: "", wrap: "" } },
                      [
                        _c(
                          "v-flex",
                          {
                            staticClass: "data-title",
                            attrs: { xs5: "", md3: "" }
                          },
                          [_vm._v("Birthdate:")]
                        ),
                        _vm._v(" "),
                        _c("v-flex", { attrs: { xs7: "", md9: "" } }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm._f("formatDate")(
                                  _vm.submissionData.birthDate
                                )
                              ) +
                              "\n          "
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("v-divider", { staticClass: "divider-class" }),
            _vm._v(" "),
            _c(
              "v-flex",
              { attrs: { xs12: "", "text-xs-left": "" } },
              [
                _c(
                  "v-layout",
                  { attrs: { row: "", wrap: "" } },
                  [
                    _c("v-icon", { attrs: { color: "secondary" } }, [
                      _vm._v("mdi-file-document")
                    ]),
                    _vm._v(" "),
                    _c("h3", { staticClass: "header-class" }, [
                      _vm._v("Service Info")
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { class: { mobile: _vm.isMobile, desktop: !_vm.isMobile } },
                  [
                    _c(
                      "v-layout",
                      { attrs: { row: "", wrap: "" } },
                      [
                        _c(
                          "v-flex",
                          {
                            staticClass: "data-title",
                            attrs: { xs5: "", md3: "" }
                          },
                          [_vm._v("Service Type:")]
                        ),
                        _vm._v(" "),
                        _c("v-flex", { attrs: { xs7: "", md9: "" } }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.submissionData.planTypeName) +
                              ": " +
                              _vm._s(_vm.submissionData.serviceType) +
                              "\n          "
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-layout",
                      { attrs: { row: "", wrap: "" } },
                      [
                        _c(
                          "v-flex",
                          {
                            staticClass: "data-title",
                            attrs: { xs5: "", md3: "" }
                          },
                          [
                            _vm.isMobile
                              ? _c("span", [_vm._v("Proj. Start Date:")])
                              : _c("span", [_vm._v("Projected Start Date:")])
                          ]
                        ),
                        _vm._v(" "),
                        _c("v-flex", { attrs: { xs7: "", md9: "" } }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm._f("formatDate")(
                                  _vm.submissionData.serviceStartDate
                                )
                              ) +
                              "\n          "
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-layout",
                      { attrs: { row: "", wrap: "" } },
                      [
                        _c(
                          "v-flex",
                          {
                            staticClass: "data-title",
                            attrs: { xs5: "", md3: "" }
                          },
                          [
                            _vm.isMobile
                              ? _c("span", [_vm._v("Proj. End Date:")])
                              : _c("span", [_vm._v("Projected End Date:")])
                          ]
                        ),
                        _vm._v(" "),
                        _c("v-flex", { attrs: { xs7: "", md9: "" } }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm._f("formatDate")(
                                  _vm.submissionData.serviceEndDate
                                )
                              ) +
                              "\n          "
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-layout",
                      { attrs: { row: "", wrap: "" } },
                      [
                        _c(
                          "v-flex",
                          {
                            staticClass: "data-title",
                            attrs: { xs5: "", md3: "" }
                          },
                          [_vm._v("Frequency:")]
                        ),
                        _vm._v(" "),
                        _c("v-flex", { attrs: { xs7: "", md9: "" } }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.submissionData.frequency) +
                              "\n            "
                          ),
                          _vm.submissionData.serviceEsy
                            ? _c("span", [_vm._v("(ESY)")])
                            : _vm._e()
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-layout",
                      { attrs: { row: "", wrap: "" } },
                      [
                        _c(
                          "v-flex",
                          {
                            staticClass: "data-title",
                            attrs: { xs5: "", md3: "" }
                          },
                          [_vm._v("Service Provider:")]
                        ),
                        _vm._v(" "),
                        _c("v-flex", { attrs: { xs7: "", md9: "" } }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.submissionData.providerFirstName +
                                  " " +
                                  _vm.submissionData.providerLastName
                              ) +
                              "\n            "
                          ),
                          _vm.submissionData.providerCredential
                            ? _c("span", [
                                _vm._v(
                                  "\n              /\n              " +
                                    _vm._s(
                                      _vm.submissionData.providerCredential
                                    ) +
                                    "\n            "
                                )
                              ])
                            : _vm._e()
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("v-divider", { staticClass: "divider-class" }),
            _vm._v(" "),
            _c(
              "v-flex",
              { attrs: { xs12: "", "text-xs-left": "" } },
              [
                _c(
                  "v-layout",
                  { attrs: { row: "", wrap: "" } },
                  [
                    _c("v-icon", { attrs: { color: "secondary" } }, [
                      _vm._v("mdi-calendar-text")
                    ]),
                    _vm._v(" "),
                    _c("h3", { staticClass: "header-class" }, [
                      _vm._v("Session Info")
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { class: { mobile: _vm.isMobile, desktop: !_vm.isMobile } },
                  [
                    _c(
                      "v-layout",
                      { attrs: { row: "", wrap: "" } },
                      [
                        _c(
                          "v-flex",
                          {
                            staticClass: "data-title",
                            attrs: { xs5: "", md3: "" }
                          },
                          [_vm._v("Session Date:")]
                        ),
                        _vm._v(" "),
                        _c("v-flex", { attrs: { xs7: "", md9: "" } }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm._f("formatDate")(
                                  _vm.submissionData.sessionDate
                                )
                              ) +
                              "\n          "
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    !_vm.isAbsent && _vm.submissionData.serviceDelivered
                      ? _c(
                          "v-layout",
                          {
                            attrs: {
                              row: "",
                              wrap: "",
                              "required:": "",
                              false: ""
                            }
                          },
                          [
                            _c(
                              "v-flex",
                              {
                                staticClass: "data-title",
                                attrs: { xs5: "", md3: "" }
                              },
                              [_vm._v("Service Delivered:")]
                            ),
                            _vm._v(" "),
                            _c("v-flex", { attrs: { xs7: "", md9: "" } }, [
                              _c(
                                "span",
                                { staticStyle: { "word-wrap": "break-word" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.submissionData.serviceDeliveredName
                                    )
                                  )
                                ]
                              )
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.hideFields
                      ? _c(
                          "v-layout",
                          { attrs: { row: "", wrap: "" } },
                          [
                            _c(
                              "v-flex",
                              {
                                staticClass: "data-title",
                                attrs: { xs5: "", md3: "" }
                              },
                              [_vm._v("Start Time (Length):")]
                            ),
                            _vm._v(" "),
                            _c("v-flex", { attrs: { xs7: "", md9: "" } }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm._f("militaryTimeToStandard")(
                                      _vm.submissionData.sessionTime
                                    )
                                  ) +
                                  "\n            (" +
                                  _vm._s(_vm.submissionData.sessionMinutes) +
                                  " mins)\n          "
                              )
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.hideFields
                      ? _c(
                          "v-layout",
                          { attrs: { row: "", wrap: "" } },
                          [
                            _c(
                              "v-flex",
                              {
                                staticClass: "data-title",
                                attrs: { xs5: "", md3: "" }
                              },
                              [_vm._v("Absent Type:")]
                            ),
                            _vm._v(" "),
                            _c("v-flex", { attrs: { xs7: "", md9: "" } }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.submissionData.absentTypeName) +
                                  "\n          "
                              )
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.hideFields && _vm.submissionData.studentAbsentReasonName
                      ? _c(
                          "v-layout",
                          { attrs: { row: "", wrap: "" } },
                          [
                            _c(
                              "v-flex",
                              {
                                staticClass: "data-title",
                                attrs: { xs5: "", md3: "" }
                              },
                              [_vm._v("Absent Reason:")]
                            ),
                            _vm._v(" "),
                            _c("v-flex", { attrs: { xs7: "", md9: "" } }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.submissionData.studentAbsentReasonName
                                  ) +
                                  "\n          "
                              )
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.hideFields && _vm.submissionData.absentAlternativeName
                      ? _c(
                          "v-layout",
                          { attrs: { row: "", wrap: "" } },
                          [
                            _c(
                              "v-flex",
                              {
                                staticClass: "data-title",
                                attrs: { xs5: "", md3: "" }
                              },
                              [_vm._v("Absent Alternative:")]
                            ),
                            _vm._v(" "),
                            _c("v-flex", { attrs: { xs7: "", md9: "" } }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.submissionData.absentAlternativeName
                                  ) +
                                  "\n          "
                              )
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.hideFields && _vm.submissionData.absentAlternativeDesc
                      ? _c(
                          "v-layout",
                          { attrs: { row: "", wrap: "" } },
                          [
                            _c(
                              "v-flex",
                              {
                                staticClass: "data-title",
                                attrs: { xs5: "", md3: "" }
                              },
                              [_vm._v("Absent Alternative Desc:")]
                            ),
                            _vm._v(" "),
                            _c("v-flex", { attrs: { xs7: "", md9: "" } }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.submissionData.absentAlternativeDesc
                                  ) +
                                  "\n          "
                              )
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.hideFields &&
                    _vm.submissionData.noServiceNotifFlag !== null
                      ? _c(
                          "v-layout",
                          { attrs: { row: "", wrap: "" } },
                          [
                            _c(
                              "v-flex",
                              {
                                staticClass: "data-title",
                                attrs: { xs5: "", md3: "" }
                              },
                              [_vm._v("Parents Informed:")]
                            ),
                            _vm._v(" "),
                            _c("v-flex", { attrs: { xs7: "", md9: "" } }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.submissionData.noServiceNotifFlagName
                                  ) +
                                  "\n          "
                              )
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "v-layout",
                      { attrs: { row: "", wrap: "" } },
                      [
                        _c(
                          "v-flex",
                          {
                            staticClass: "data-title",
                            attrs: { xs5: "", md3: "" }
                          },
                          [_vm._v("Location:")]
                        ),
                        _vm._v(" "),
                        _c("v-flex", { attrs: { xs7: "", md9: "" } }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.submissionData.locationName) +
                              "\n            "
                          ),
                          _vm.submissionData.locationOther
                            ? _c(
                                "span",
                                { staticStyle: { "word-wrap": "break-word" } },
                                [
                                  _vm._v(
                                    " - " +
                                      _vm._s(_vm.submissionData.locationOther)
                                  )
                                ]
                              )
                            : _vm._e()
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    !_vm.hideFields && _vm.isGroup
                      ? _c(
                          "v-layout",
                          { attrs: { row: "", wrap: "" } },
                          [
                            _c(
                              "v-flex",
                              {
                                staticClass: "data-title",
                                attrs: { xs5: "", md3: "" }
                              },
                              [_vm._v("Group Type:")]
                            ),
                            _vm._v(" "),
                            _c("v-flex", { attrs: { xs7: "", md9: "" } }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.submissionData.groupTypeName) +
                                  "\n          "
                              )
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.hideFields &&
                    !_vm.isConSultationService &&
                    _vm.submissionData.groupSize
                      ? _c(
                          "v-layout",
                          { attrs: { row: "", wrap: "" } },
                          [
                            _c(
                              "v-flex",
                              {
                                staticClass: "data-title",
                                attrs: { xs5: "", md3: "" }
                              },
                              [_vm._v("Group Size:")]
                            ),
                            _vm._v(" "),
                            _vm.submissionData.groupSize
                              ? _c("v-flex", { attrs: { xs7: "", md9: "" } }, [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.submissionData.groupSize) +
                                      "\n          "
                                  )
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.submissionData.deliveryModeName && !_vm.isAbsent
                      ? _c(
                          "v-layout",
                          { attrs: { row: "", wrap: "" } },
                          [
                            _c(
                              "v-flex",
                              {
                                staticClass: "data-title",
                                attrs: { xs5: "", md3: "" }
                              },
                              [_vm._v("Delivery Mode:")]
                            ),
                            _vm._v(" "),
                            _c("v-flex", { attrs: { xs7: "", md9: "" } }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.submissionData.deliveryModeName) +
                                  "\n          "
                              )
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.submissionData.roomName && !_vm.isAbsent
                      ? _c(
                          "v-layout",
                          {
                            attrs: {
                              row: "",
                              wrap: "",
                              "required:": "",
                              false: ""
                            }
                          },
                          [
                            _c(
                              "v-flex",
                              {
                                staticClass: "data-title",
                                attrs: { xs5: "", md3: "" }
                              },
                              [_vm._v("Classroom Number:")]
                            ),
                            _vm._v(" "),
                            _c("v-flex", { attrs: { xs7: "", md9: "" } }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.submissionData.roomName) +
                                  "\n          "
                              )
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isAbsent && _vm.submissionData.providerLocation
                      ? _c(
                          "v-layout",
                          {
                            attrs: {
                              row: "",
                              wrap: "",
                              "required:": "",
                              false: ""
                            }
                          },
                          [
                            _c(
                              "v-flex",
                              {
                                staticClass: "data-title",
                                attrs: { xs5: "", md3: "" }
                              },
                              [_vm._v("Provider Location:")]
                            ),
                            _vm._v(" "),
                            _c("v-flex", { attrs: { xs7: "", md9: "" } }, [
                              _c(
                                "span",
                                { staticStyle: { "word-wrap": "break-word" } },
                                [
                                  _vm._v(
                                    _vm._s(_vm.submissionData.providerLocation)
                                  )
                                ]
                              )
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.submissionData.notes && !_vm.isAbsent
                      ? _c(
                          "v-layout",
                          {
                            attrs: {
                              row: "",
                              wrap: "",
                              "required:": "",
                              false: ""
                            }
                          },
                          [
                            _c(
                              "v-flex",
                              {
                                staticClass: "data-title",
                                attrs: { xs5: "", md3: "" }
                              },
                              [_vm._v("Comments:")]
                            ),
                            _vm._v(" "),
                            _c("v-flex", { attrs: { xs7: "", md9: "" } }, [
                              _c(
                                "span",
                                { staticStyle: { "word-wrap": "break-word" } },
                                [_vm._v(_vm._s(_vm.submissionData.notes))]
                              )
                            ])
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("v-divider", { staticClass: "divider-class" }),
            _vm._v(" "),
            !_vm.hideFields & !_vm.isAbsent && !_vm.isConSultationService
              ? _c(
                  "v-flex",
                  { attrs: { xs12: "", "text-xs-left": "" } },
                  [
                    _c(
                      "v-layout",
                      { attrs: { row: "", wrap: "" } },
                      [
                        _c("v-icon", { attrs: { color: "secondary" } }, [
                          _vm._v("mdi-calendar-plus")
                        ]),
                        _vm._v(" "),
                        _c("h3", { staticClass: "header-class" }, [
                          _vm._v(
                            "Documentation of Service and Student Performance"
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        class: { mobile: _vm.isMobile, desktop: !_vm.isMobile }
                      },
                      [
                        _c(
                          "v-layout",
                          { attrs: { row: "", wrap: "" } },
                          [
                            _c(
                              "v-flex",
                              {
                                staticClass: "data-title",
                                attrs: { xs12: "", sm5: "", md4: "" }
                              },
                              [
                                _vm.isMobile
                                  ? _c("span", [_vm._v("Total Reimb. Mins:")])
                                  : _c("span", [
                                      _vm._v("Total Reimbursable Minutes:")
                                    ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-flex",
                              { attrs: { xs12: "", sm7: "", md8: "" } },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.submissionData.medicaidMinutes) +
                                    " mins\n          "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.submissionData.medicaidSessions.length
                          ? _c(
                              "div",
                              _vm._l(
                                _vm.submissionData.medicaidSessions,
                                function(session, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: index,
                                      staticClass: "session-container"
                                    },
                                    [
                                      _c("v-divider"),
                                      _vm._v(" "),
                                      _c(
                                        "v-layout",
                                        {
                                          staticClass: "session-row",
                                          attrs: { row: "", wrap: "" }
                                        },
                                        [
                                          _c(
                                            "v-flex",
                                            {
                                              staticClass: "data-title",
                                              attrs: {
                                                xs12: "",
                                                sm5: "",
                                                md4: ""
                                              }
                                            },
                                            [_vm._v("Minutes:")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            {
                                              attrs: {
                                                xs12: "",
                                                sm7: "",
                                                md8: ""
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(session.minutes) +
                                                  " mins\n              "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-layout",
                                        {
                                          staticClass: "session-row",
                                          attrs: { row: "", wrap: "" }
                                        },
                                        [
                                          _c(
                                            "v-flex",
                                            {
                                              staticClass: "data-title",
                                              attrs: {
                                                xs12: "",
                                                sm5: "",
                                                md4: ""
                                              }
                                            },
                                            [_vm._v("Procedure Description:")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            {
                                              attrs: {
                                                xs12: "",
                                                sm7: "",
                                                md8: ""
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    session.procedureName
                                                  ) +
                                                  "\n              "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                }
                              ),
                              0
                            )
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    !_vm.hideFields && !_vm.isConSultationService
                      ? _c("v-divider", { staticClass: "divider-class" })
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.isAbsent
              ? _c("v-flex", { attrs: { xs12: "", "text-xs-left": "" } }, [
                  _c(
                    "div",
                    { class: { mobile: _vm.isMobile, desktop: !_vm.isMobile } },
                    [
                      _c(
                        "v-spacer",
                        [
                          !_vm.hideFields && !_vm.isConSultationService
                            ? _c(
                                "v-layout",
                                { attrs: { row: "", wrap: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      staticClass: "data-title",
                                      staticStyle: { "padding-bottom": "10px" },
                                      attrs: { xs12: "", sm5: "", md4: "" }
                                    },
                                    [_vm._v("Relevant Student Behavior:")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      staticClass: "behavior-container",
                                      staticStyle: { "padding-bottom": "15px" },
                                      attrs: { xs12: "", sm7: "", md8: "" }
                                    },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(
                                            _vm.formatSessionValues(
                                              _vm.submissionData
                                                .otSessionBehaviors
                                            )
                                          ) +
                                          "\n          "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("v-flex")
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.hideFields && !_vm.isConSultationService
                            ? _c(
                                "v-layout",
                                { attrs: { row: "", wrap: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      staticClass: "data-title",
                                      staticStyle: { "padding-bottom": "10px" },
                                      attrs: { xs12: "", sm5: "", md4: "" }
                                    },
                                    [
                                      _vm._v(
                                        "Relevant Student Behavior Details:"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      staticClass: "behavior-container",
                                      staticStyle: { "padding-bottom": "15px" },
                                      attrs: { xs12: "", sm7: "", md8: "" }
                                    },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(
                                            _vm.submissionData.studentBehavior
                                          ) +
                                          "\n          "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("v-flex")
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.isConSultationService
                            ? _c("v-divider", {
                                staticClass: "divider-half-class"
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._l(
                            _vm.submissionData.otSessionObjectives,
                            function(objective, i) {
                              return !_vm.hideFields
                                ? _c(
                                    "v-flex",
                                    {
                                      key: i,
                                      staticStyle: { "padding-bottom": "15px" },
                                      attrs: { xs12: "", "text-xs-left": "" }
                                    },
                                    [
                                      !_vm.hideFields
                                        ? _c(
                                            "v-layout",
                                            { attrs: { row: "", wrap: "" } },
                                            [
                                              _c(
                                                "v-flex",
                                                {
                                                  staticClass: "data-title",
                                                  attrs: {
                                                    xs12: "",
                                                    sm5: "",
                                                    md4: ""
                                                  }
                                                },
                                                [_vm._v("Objective:")]
                                              ),
                                              _vm._v(" "),
                                              objective.value !== "OTHER"
                                                ? _c(
                                                    "v-flex",
                                                    {
                                                      staticClass:
                                                        "objectivenote-container",
                                                      staticStyle: {
                                                        "padding-bottom": "10px"
                                                      },
                                                      attrs: {
                                                        xs12: "",
                                                        sm7: "",
                                                        md8: ""
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n              " +
                                                          _vm._s(
                                                            objective.name
                                                          ) +
                                                          "\n            "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              objective.value === "OTHER"
                                                ? _c(
                                                    "v-flex",
                                                    {
                                                      staticClass:
                                                        "objectivenote-container",
                                                      staticStyle: {
                                                        "padding-bottom": "10px"
                                                      },
                                                      attrs: {
                                                        xs12: "",
                                                        sm7: "",
                                                        md8: ""
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n              " +
                                                          _vm._s(
                                                            objective.name +
                                                              ": " +
                                                              objective.objectiveOther
                                                          ) +
                                                          "\n            "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.hideFields
                                        ? _c(
                                            "v-layout",
                                            { attrs: { row: "", wrap: "" } },
                                            [
                                              _c(
                                                "v-flex",
                                                {
                                                  staticClass: "data-title",
                                                  staticStyle: {
                                                    "padding-bottom": "15px"
                                                  },
                                                  attrs: {
                                                    xs12: "",
                                                    sm5: "",
                                                    md4: ""
                                                  }
                                                },
                                                [_vm._v("Implementations:")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-flex",
                                                {
                                                  staticClass:
                                                    "objectivenote-container",
                                                  attrs: {
                                                    xs12: "",
                                                    sm7: "",
                                                    md8: ""
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n              " +
                                                      _vm._s(
                                                        _vm.formatImplementationValues(
                                                          _vm.submissionData
                                                            .otSessionImplementations,
                                                          objective.id
                                                        )
                                                      ) +
                                                      "\n            "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.submissionData.otSessionObjectives
                                        .length > 1
                                        ? _c("v-divider", {
                                            staticClass: "divider-half-class"
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                : _vm._e()
                            }
                          ),
                          _vm._v(" "),
                          !_vm.hideFields
                            ? _c(
                                "v-layout",
                                { attrs: { row: "", wrap: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      staticClass: "data-title",
                                      staticStyle: { "padding-bottom": "10px" },
                                      attrs: { xs12: "", sm5: "", md4: "" }
                                    },
                                    [_vm._v("Objective Details:")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      staticClass:
                                        "progressAssessment-container",
                                      attrs: { xs12: "", sm7: "", md8: "" }
                                    },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(
                                            _vm.submissionData.objectiveNotes
                                          ) +
                                          "\n          "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("v-divider", {
                            staticClass: "divider-half-class"
                          }),
                          _vm._v(" "),
                          _vm._l(
                            _vm.submissionData.otSessionProgressCodes,
                            function(progressCodes, i) {
                              return !_vm.hideFields &&
                                !_vm.isConSultationService
                                ? _c(
                                    "v-flex",
                                    {
                                      key: i,
                                      attrs: { xs12: "", "text-xs-left": "" }
                                    },
                                    [
                                      !_vm.hideFields
                                        ? _c(
                                            "v-layout",
                                            { attrs: { row: "", wrap: "" } },
                                            [
                                              _c(
                                                "v-flex",
                                                {
                                                  staticClass: "data-title",
                                                  staticStyle: {
                                                    "padding-bottom": "10px"
                                                  },
                                                  attrs: {
                                                    xs12: "",
                                                    sm5: "",
                                                    md4: ""
                                                  }
                                                },
                                                [_vm._v("Task:")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-flex",
                                                {
                                                  staticClass:
                                                    "objectivenote-container",
                                                  attrs: {
                                                    xs12: "",
                                                    sm7: "",
                                                    md8: ""
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n              " +
                                                      _vm._s(
                                                        progressCodes.task
                                                      ) +
                                                      "\n            "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.hideFields
                                        ? _c(
                                            "v-layout",
                                            { attrs: { row: "", wrap: "" } },
                                            [
                                              _c(
                                                "v-flex",
                                                {
                                                  staticClass: "data-title",
                                                  staticStyle: {
                                                    "padding-bottom": "5px",
                                                    "padding-left": "15px"
                                                  },
                                                  attrs: {
                                                    xs12: "",
                                                    sm5: "",
                                                    md4: ""
                                                  }
                                                },
                                                [_vm._v("Measurable Data:")]
                                              ),
                                              _vm._v(" "),
                                              _vm._l(
                                                _vm.submissionData
                                                  .otSessionProgressMeasures,
                                                function(
                                                  progressMeasure,
                                                  index
                                                ) {
                                                  return _c(
                                                    "v-flex",
                                                    {
                                                      key: index,
                                                      style: {
                                                        "padding-left": !_vm.isMobile
                                                          ? "280px"
                                                          : "50px",
                                                        "padding-bottom": "1px"
                                                      },
                                                      attrs: {
                                                        xs12: "",
                                                        sm12: "",
                                                        md12: ""
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n              " +
                                                          _vm._s(
                                                            _vm.formatProgressMeasures(
                                                              [progressMeasure],
                                                              progressCodes.id
                                                            )
                                                          ) +
                                                          "\n            "
                                                      )
                                                    ]
                                                  )
                                                }
                                              )
                                            ],
                                            2
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.hideFields
                                        ? _c(
                                            "v-layout",
                                            { attrs: { row: "", wrap: "" } },
                                            [
                                              _c(
                                                "v-flex",
                                                {
                                                  staticClass: "data-title",
                                                  staticStyle: {
                                                    "padding-bottom": "5px",
                                                    "padding-left": "15px"
                                                  },
                                                  attrs: {
                                                    xs12: "",
                                                    sm5: "",
                                                    md4: ""
                                                  }
                                                },
                                                [_vm._v("Level of Assistance:")]
                                              ),
                                              _vm._v(" "),
                                              _vm._l(
                                                _vm.submissionData
                                                  .otSessionProgressAssistance,
                                                function(assistance, index) {
                                                  return _c(
                                                    "v-flex",
                                                    {
                                                      key: index,
                                                      style: {
                                                        "padding-left": !_vm.isMobile
                                                          ? "280px"
                                                          : "50px",
                                                        "padding-bottom": "1px"
                                                      },
                                                      attrs: {
                                                        xs12: "",
                                                        sm12: "",
                                                        md12: ""
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n              " +
                                                          _vm._s(
                                                            _vm.formatProgressAssistance(
                                                              [assistance],
                                                              progressCodes.id
                                                            )
                                                          ) +
                                                          "\n            "
                                                      )
                                                    ]
                                                  )
                                                }
                                              )
                                            ],
                                            2
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.hideFields
                                        ? _c(
                                            "v-layout",
                                            { attrs: { row: "", wrap: "" } },
                                            [
                                              _c(
                                                "v-flex",
                                                {
                                                  staticClass: "data-title",
                                                  staticStyle: {
                                                    "padding-bottom": "5px",
                                                    "padding-left": "15px"
                                                  },
                                                  attrs: {
                                                    xs12: "",
                                                    sm5: "",
                                                    md4: ""
                                                  }
                                                },
                                                [_vm._v("Type of Assistance:")]
                                              ),
                                              _vm._v(" "),
                                              _vm._l(
                                                _vm.submissionData
                                                  .otSessionProgressTypes,
                                                function(type, index) {
                                                  return _c(
                                                    "v-flex",
                                                    {
                                                      key: index,
                                                      style: {
                                                        "padding-left": !_vm.isMobile
                                                          ? "280px"
                                                          : "50px",
                                                        "padding-bottom": "1px"
                                                      },
                                                      attrs: {
                                                        xs12: "",
                                                        sm12: "",
                                                        md12: ""
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n              " +
                                                          _vm._s(
                                                            _vm.formatProgressTypes(
                                                              [type],
                                                              progressCodes.id
                                                            )
                                                          ) +
                                                          "\n            "
                                                      )
                                                    ]
                                                  )
                                                }
                                              )
                                            ],
                                            2
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.submissionData.otSessionProgressTypes
                                        .length > 1
                                        ? _c("v-divider", {
                                            staticClass: "divider-half-class"
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                : _vm._e()
                            }
                          ),
                          _vm._v(" "),
                          !_vm.hideFields && !_vm.isConSultationService
                            ? _c(
                                "v-layout",
                                { attrs: { row: "", wrap: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      staticClass: "data-title",
                                      staticStyle: { "padding-bottom": "15px" },
                                      attrs: { xs12: "", sm5: "", md4: "" }
                                    },
                                    [_vm._v("Performance/Progress Notes:")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      staticClass: "behavior-container",
                                      staticStyle: { "padding-bottom": "15px" },
                                      attrs: { xs12: "", sm7: "", md8: "" }
                                    },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(
                                            _vm.submissionData
                                              .progressAssessment
                                          ) +
                                          "\n          "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("v-flex")
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.hideFields
                            ? _c(
                                "v-layout",
                                { attrs: { row: "", wrap: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      staticClass: "data-title",
                                      staticStyle: { "padding-bottom": "15px" },
                                      attrs: { xs12: "", sm5: "", md4: "" }
                                    },
                                    [_vm._v("Next Session Focus(es):")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      staticClass: "behavior-container",
                                      staticStyle: { "padding-bottom": "15px" },
                                      attrs: { xs12: "", sm7: "", md8: "" }
                                    },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(
                                            _vm.submissionData.nextSessionFocus
                                          ) +
                                          "\n          "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("v-flex")
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.hideFields
                            ? _c(
                                "v-layout",
                                { attrs: { row: "", wrap: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      staticClass: "data-title",
                                      staticStyle: { "padding-bottom": "15px" },
                                      attrs: { xs12: "", sm5: "", md4: "" }
                                    },
                                    [_vm._v("Next Session Goal(s):")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      staticClass: "behavior-container",
                                      staticStyle: { "padding-bottom": "15px" },
                                      attrs: { xs12: "", sm7: "", md8: "" }
                                    },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(
                                            _vm.submissionData.nextSessionGoal
                                          ) +
                                          "\n          "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("v-flex")
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.hideFields
                            ? _c(
                                "v-layout",
                                { attrs: { row: "", wrap: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      staticClass: "data-title",
                                      staticStyle: { "padding-bottom": "15px" },
                                      attrs: { xs12: "", sm5: "", md4: "" }
                                    },
                                    [_vm._v("Session Notes:")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      staticClass: "behavior-container",
                                      staticStyle: { "padding-bottom": "15px" },
                                      attrs: { xs12: "", sm7: "", md8: "" }
                                    },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(
                                            _vm.submissionData.sessionNotes
                                          ) +
                                          "\n          "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("v-flex")
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        2
                      ),
                      _vm._v(" "),
                      !_vm.hideFields
                        ? _c("v-divider", { staticClass: "divider-class" })
                        : _vm._e()
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("v-flex", { attrs: { xs12: "", "text-xs-left": "" } }, [
              _vm.submissionData.credentialType != "OT" &&
              _vm.submissionData.supervisorName
                ? _c(
                    "div",
                    [
                      _c(
                        "div",
                        {
                          class: {
                            mobile: _vm.isMobile,
                            desktop: !_vm.isMobile
                          }
                        },
                        [
                          _c(
                            "v-spacer",
                            [
                              _c(
                                "v-layout",
                                { attrs: { row: "", wrap: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      staticClass: "data-title",
                                      attrs: { xs12: "", sm5: "", md3: "" }
                                    },
                                    [_vm._v("Supervision Signature:")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      staticClass: "behavior-container",
                                      attrs: { xs12: "", sm7: "", md9: "" }
                                    },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(
                                            _vm.submissionData.supervisorName +
                                              " / " +
                                              _vm.submissionData
                                                .supervisorCredential +
                                              ", " +
                                              _vm.convertDisplayedDate(
                                                _vm.submissionData
                                                  .supervisorDate
                                              )
                                          ) +
                                          "\n          "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("v-flex", { attrs: { md3: "" } })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-divider", { staticClass: "divider-class" })
                    ],
                    1
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("v-flex", { attrs: { xs12: "", "text-xs-left": "" } }, [
              _vm.submissionData.credentialType != "OT" &&
              !_vm.submissionData.supervisorName
                ? _c(
                    "div",
                    [
                      _c(
                        "div",
                        {
                          class: {
                            mobile: _vm.isMobile,
                            desktop: !_vm.isMobile
                          }
                        },
                        [
                          _c(
                            "v-spacer",
                            [
                              _c(
                                "v-layout",
                                { attrs: { row: "", wrap: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      staticClass: "data-title",
                                      attrs: { xs12: "", sm5: "", md3: "" }
                                    },
                                    [_vm._v("Supervision Signature:")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      staticClass: "behavior-container",
                                      attrs: { xs12: "", sm7: "", md9: "" }
                                    },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s("Not Completed") +
                                          "\n          "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("v-flex", { attrs: { md3: "" } })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-divider", { staticClass: "divider-class" })
                    ],
                    1
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _c(
              "v-flex",
              { attrs: { xs12: "", "text-xs-left": "" } },
              [
                _c(
                  "v-layout",
                  { attrs: { row: "", wrap: "" } },
                  [
                    _c("v-icon", { attrs: { color: "secondary" } }, [
                      _vm._v("mdi-timer")
                    ]),
                    _vm._v(" "),
                    _c("h3", { staticClass: "header-class" }, [
                      _vm._v("Audit Log")
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { class: { mobile: _vm.isMobile, desktop: !_vm.isMobile } },
                  _vm._l(_vm.submissionData.logs, function(log, index) {
                    return _c("div", { key: index }, [
                      _vm._v("\n          " + _vm._s(log.username)),
                      _c("br"),
                      _vm._v(" "),
                      _c("small", [
                        _vm._v(
                          _vm._s(log.updateName) +
                            " " +
                            _vm._s(
                              _vm._f("formatDateWithTime")(log.updatedDate)
                            )
                        )
                      ])
                    ])
                  }),
                  0
                )
              ],
              1
            )
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.pageReady
      ? _c("div", { staticClass: "text-xs-center" }, [_c("loading-spinner")], 1)
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-97156f4c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-97156f4c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/service-log/confirmation-page.vue
// module id = null
// module chunks = 